import { useBehavior, useCheckBox } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreInputData } from '../types/data';
import { TCoreCheckboxOptions } from '../types/options';
import { CoreSwitchView } from './CoreSwitchView';

const CoreSwitchWidget = ({ widget }: TWidgetProps<TCoreInputData, TCoreCheckboxOptions>) => {
    const { isDisabled, isHidden } = useBehavior(widget);
    const { handleChange, isChecked } = useCheckBox(widget, { skipValidation: true });

    return (
        <CoreSwitchView
            widget={widget}
            uid={widget.uid}
            isDisabled={isDisabled}
            isHide={isHidden}
            isChecked={isChecked}
            handleChange={handleChange}
            styleName={widget.options?.style}
        />
    );
};

export { CoreSwitchWidget };
